import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  Stack,
  Typography,
} from "@mui/material"
import { useTranslation } from "react-i18next"
import { styles } from "./styles/MessageAnnouncement.styles"
import { useThemeContext } from "contexts/ThemeContext"
import ReactPlayer from "react-player"
import { FILE_TYPES } from "pages/student/activity/common/constants"
import Image from "components/Image"
import TeacherAvatar from "components/Teacher/TeacherAvatar"

export default function MessageAnnouncementModal({
  open,
  onClose,
  onReply = () => {},
  messagePreview,
  icon,
  files,
  showTeacherInfo = false,
  fontSize,
  backColor,
  replyVisible = false,
  replyText,
}) {
  const { t } = useTranslation()
  const { bgColor } = useThemeContext()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: styles.dialog,
      }}
    >
      <DialogContent sx={styles.content}>
        <Stack direction={"row"} sx={styles.mainContent}>
          <Stack
            sx={[styles.leftContent, backColor && { background: backColor }]}
          >
            <Stack sx={styles.messageBox}>
              <Typography
                sx={styles.message}
                fontSize={fontSize || "calc(20px + 1vw)"}
              >
                {messagePreview}
              </Typography>
              {files?.find((f) => f.fileTypeId === FILE_TYPES.AUDIO) && (
                <audio
                  src={
                    files.find((f) => f.fileTypeId === FILE_TYPES.AUDIO).fileURL
                  }
                  controls
                />
              )}
              {files?.find((f) => f.fileTypeId === FILE_TYPES.IMAGE) && (
                <Image
                  src={
                    files.find((f) => f.fileTypeId === FILE_TYPES.IMAGE).fileURL
                  }
                  alt="announcement"
                  width="auto"
                  height="auto"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    marginTop: "15px",
                    marginBottom: "15px",
                  }}
                />
              )}
            </Stack>
            <Button sx={styles.acceptButton} onClick={onClose}>
              {t("accept")}
            </Button>
            {replyVisible && (
              <Button
                disableElevation
                variant="text"
                sx={[styles.acceptButton, styles.replyButton]}
                onClick={onReply}
              >
                {replyText || t("Reply")}
              </Button>
            )}
          </Stack>
          <Stack
            className="rightContent"
            sx={[
              styles.rightContent,
              { backgroundColor: bgColor },
              showTeacherInfo && {
                justifyContent: "center",
                alignItems: "center",
              },
            ]}
          >
            {showTeacherInfo ? (
              <TeacherAvatar showInfo />
            ) : (
              <Avatar src={icon} sx={styles.avatar} />
            )}
            {!showTeacherInfo && (
              <ReactPlayer
                url={require("assets/img/common/teacher_speak.mp4")}
                playing={true}
                loop={true}
                muted={true}
                playsinline={true}
                width="100%"
                height="100%"
              />
            )}
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}
